import { useCallback, useState } from 'react';
import { useController, useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';

import { useTablePagination } from '@speeki/global-ui-components';

import { GetSurveysForUserDocument } from '@graphql/generated/graphql';

import { ExcludedSurveyService } from '@services/ExcludedSurveyService';

import { useLazyQuery, useReactiveVar } from '@apollo/client';
import { authVar } from '@boot/reactiveVariables.ts';

interface SearchForm {
    search: string;
}

export const useSurveyListPageLogic = () => {
    const [searchValue, setSearchValue] = useState('');
    const isGuest = useReactiveVar(authVar).isGuest;

    const navigate = useNavigate();
    const { control, register, reset } = useForm<SearchForm>();

    const { field } = useController({
        control,
        defaultValue: '',
        name: 'search',
    });

    const [getSurveysForUser, { called, data: userSurveyData, loading }] =
        useLazyQuery(GetSurveysForUserDocument, {
            fetchPolicy: 'cache-and-network',
        });

    const surveyList = userSurveyData?.list.nodes;

    console.log('isGuest', isGuest);

    const handleGetSurveyList = useCallback(
        ({
            limit,
            offset,
            searchPhrase,
        }: {
            limit: number;
            offset: number;
            searchPhrase?: string;
        }) => {
            const excludedUuids =
                ExcludedSurveyService.getExcludedSurvey() || [];

            void getSurveysForUser({
                variables: {
                    input: {
                        excludedUuids: isGuest ? excludedUuids : [],
                        freeTextQuery: searchPhrase,
                        paging: {
                            limit,
                            offset,
                        },
                        sorting: [
                            { direction: 'DESC', field: 'lastUpdatedAt' },
                        ],
                    },
                },
            });
        },
        [getSurveysForUser],
    );

    const pagination = useTablePagination({
        onPageChange: handleGetSurveyList,
        searchPhrase: searchValue,
        testId: '',
        totalCount: userSurveyData?.list.totalCount ?? 0,
    });

    const onSearch = () => {
        setSearchValue(field.value);
        pagination.gotoPage(1);
    };

    const onReset = () => {
        setSearchValue('');
        reset();
        pagination.gotoPage(1);
    };

    const isLoading = loading || !called;

    return {
        field,
        isLoading,
        navigate,
        onReset,
        onSearch,
        pagination,
        register,
        searchValue,
        surveyList,
    };
};
